module.exports = __webpack_public_path__ + "static/media/extra-video.4d29486c.png";